/**
 * Résout une URL contenant des placeholders (ex: {prospect}) en utilisant un objet de paramètres.
 * Les paramètres non utilisés dans les placeholders sont ajoutés en tant que query parameters.
 *
 * @param {string} url - L'URL brute avec des placeholders.
 * @param {Object} params - Les paramètres à injecter.
 * @returns {string} - L'URL résolue.
 */
export function resolveUrl(url, params = {}) {
    if (!url) return '';

    let resolvedUrl = url;
    const usedParams = new Set();

    // Remplacement des placeholders {key}
    resolvedUrl = resolvedUrl.replace(/\{([a-zA-Z0-9_-]+)\}/g, (match, key) => {
        if (params[key] !== undefined) {
            usedParams.add(key);
            return params[key];
        }
        return match;
    });

    // Ajout des paramètres restants en tant que search parameters
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
        if (!usedParams.has(key)) {
            queryParams.append(key, params[key]);
        }
    });

    const queryString = queryParams.toString();
    if (queryString) {
        resolvedUrl += (resolvedUrl.includes('?') ? '&' : '?') + queryString;
    }

    return resolvedUrl;
}
